// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__2hZcM","rotate":"Loader_rotate__3QseU"};